import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../gd-popover/@const"
import Relation from "../../../model2/relation/relation"
import PopoverMenuOption from "../../popover-menu/popover-menu/menu-option"
import itemRouteUrl from "../actions/item-route-url"

type Props = {
    className?  : string
    relation    : Relation
    onRemove?   : {(id: ID): void}      // omitted when the viewer cannot edit -- then there is no Delete
}

type State = {
    showPopover: boolean
}

// The "..." of a related-item row: the control, its popover and the two options
// inside it. Every renderer (list / glist / popover row) drops it in as one piece.
//
// Delete defers to the caller's onRemove, which owns the confirmation dialog.
export default class RelatedItemMoreMenu extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {showPopover: false}
    }

    // stopPropagation keeps the row's own onClick from navigating behind the menu.
    onClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        this.setState({showPopover: !this.state.showPopover})
    }

    hidePopover = () => {
        this.setState({showPopover: false})
    }

    onOpenNewWindow = () => {
        const url = itemRouteUrl(this.props.relation)
        if (url) gd.openInNewWindow(url)
        this.hidePopover()
    }

    // The LINK's id -- that is what a delete removes.
    onDelete = () => {
        this.props.onRemove?.(this.props.relation.id)
        this.hidePopover()
    }

    renderMenu = () => {

        const options: any[] = [
            {
                icon    : "i5-open-new-window",
                label   : "Open in new window",
                onClick : this.onOpenNewWindow,
            },
        ]

        if (this.props.onRemove) {
            options.push('separator')
            options.push({
                icon    : "i5-trash-alt",
                label   : "Delete",
                onClick : this.onDelete,
            })
        }

        return (
            <div className="ui5-popover-menu min-w-200">
                {_.map(options, (option: any, key) => {
                    if (option === 'separator') return <div key={key} className="separator"/>
                    return <PopoverMenuOption key={key} option={option}/>
                })}
            </div>
        )
    }

    renderPopover = () => {
        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
            attachmentType  : PopoverAttachmentType.HORIZONTAL,
        })

        return (
            <Popover popoverClass     = "gd-view-more-popover"
                     position           = {popoverPosition}
                     getTargetFunc      = {() => findDOMNode(this)}
                     onClickOutside     = {this.hidePopover}>

                {this.renderMenu()}
            </Popover>
        )
    }

    render() {
        // visible-on-show-popover + show-popover keeps the "..." visible while
        // its menu is open, even after the mouse leaves the row (the row's
        // visible-on-parent-hover would otherwise hide it).
        const classes = Classes(
            "ui5-control-button s-26 fs-20 ui5-ico-more visible-on-show-popover",
            this.props.className,
            {"show-popover": this.state.showPopover},
        )

        return (
            <div className={classes} onClick={this.onClick}>
                {this.state.showPopover && this.renderPopover()}
            </div>
        )
    }
}
